/**
 * Checks if the browser supports the Web Share API and whether or not the given
 * shareData is shareable with it
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_Share_API
 *
 * @param {ShareData} shareData
 */
export const canShareNatively = shareData =>
  typeof navigator === "object" &&
  typeof navigator.canShare === "function" &&
  typeof navigator.share === "function" &&
  navigator.canShare(shareData);

/**
 * Opens the browser's built-in share tool with the given shareData
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_Share_API
 *
 * @param {ShareData} shareData
 */
export const openNativeShareTool = shareData => navigator.share(shareData);

export const copyTextToClipboard = async (content, callback) => {
  try {
    await navigator.clipboard.writeText(content);
  } catch (err) {
    console.error(
      "Try to copy by execCommand due to failed on Clipboard API writeText: ",
      err
    );
    const el = document.createElement("textarea");
    el.value = content;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy"); // works in more restricted contexts
    document.body.removeChild(el);
  }

  callback();
};
